import axios from 'axios';
import swal from 'sweetalert2';// import sweet alert

const perPage = 20;

const state = {
    accessToken: localStorage.getItem('access_token') || null,
    cpdId: localStorage.getItem('access_token') || null,
    cpd: {},
    lock: false,
    uploadProgress: null,
    perPage: perPage,
    notifications: {},
    locations: {},
    lastFetch: 0,
    preferredMethod: localStorage.getItem('method') || null
};

const getters = {
    isLoggedIn: state => state.accessToken !== null && state.cpdId !== null ? true : false,
    cpd: state => state.cpd,
    lock: state => state.cpd && (state.cpd.profile_lock == 'yes') ? true : false,
    notifications: state => state.notifications,
    locations: state => state.locations,
    shouldUpdate: (state) => {
        const lastFetch = state.lastFetch;
        if (!lastFetch) return true; // Always fetch if never fetched
        const fiveMinutes = 5 * 60 * 1000;
        return (Date.now() - lastFetch) > fiveMinutes;
    },
    getCpdAccessToken: state => state.accessToken,
    getPreferredMethod: state => state.preferredMethod
};

const actions = {
async updateCpdProfile({ state, getters, rootState, commit }, status = false) {// fetch profile only not cached 
        if (!getters.shouldUpdate && ! status) {
            console.log("Using cached products.");
            return state.user; // Exit early if the cache is still fresh
        }
        console.log("updating from server");
        try {
            const url = rootState.url.cpdProfileUrl;
            const header = {Authorization: `Bearer ${state.accessToken}`};
            const response = await axios.post(url, {}, { headers: header });// make api call
            commit('setCpd', response.data.cpd);
            return response.data.cpd;
        } catch (error) {
            swal.fire("Session Expired!", "Your session has expired please log in again to continue", "warning");
            localStorage.removeItem('access_token');// remove token
            localStorage.removeItem('time_out');// remove time out
            localStorage.removeItem('method');// remove time out
            state.accessToken = null;
            return setTimeout(() => { window.location.href = '/'; }, 2000);// redirect to login
        }
    },
    async fetchCpdProfile(state) {// fetch user profile
        const url = state.rootState.url.cpdProfileUrl;
        const header = {Authorization: `Bearer ${state.accessToken}`};
        const response = await axios.post(url, {}, { headers: header });// make api call
        state.commit('setCpd', response.data.cpd);
        return response.data.cpd;
    },
    async createSignup(state, data) {// signup
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.createSignupUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    destroyAccessToken(state) {// destroy local storage
        localStorage.removeItem('access_token');// remove token
        localStorage.removeItem('time_out');// remove time out
        localStorage.removeItem('method');// remove time out
        state.accessToken = null;
        return setTimeout(() => { window.location.href = '/'; }, 2000);// redirect to login
    },
    storeAndLoginUser(state, data) {//set token and login user
        let hours = 2;
        localStorage.setItem('access_token', data.access_token);// set access token
        localStorage.setItem('method', data.preferred_method);// set access token
        localStorage.setItem('time_out', new Date().getTime() + (hours * 60 * 60 * 1000));// set timeout
    },
    async cpdLogin(state, data) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.cpdLoginUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    async getCpdNotifications(state, limit) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getCpdNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { limit : limit }, { headers: header });// make api call
        state.commit('setCpdNotifications', response.data);
        return response.data;
    },
    async getCpdNotification(state, slug) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.getCpdNotificationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { slug : slug }, { headers: header });// make api call
        return response.data;
    },
    async deleteCpdNotification(state, id) {// fetch user profile
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.deleteCpdNotificationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, { id : id }, { headers: header });// make api call
        return response.data;
    },
    updatePhotoName({ commit }, fileName) {// update photo name
        commit('setUpdatePhotoName', fileName);// set update photo function
    },
    async uploadUserPhoto(state, data) {// upload user documents
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.uploadCpdPhotoUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        let response = await axios.post(url, data, {
            headers: header,
            onUploadProgress: uploadEvent => {
                state.state.uploadProgress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
            }
        });// make api call
        return response.data;
    },
    async changePassword(state, data) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.changePasswordUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data, { headers: header });// make api call
        return response.data;
    },
    async getLocations(state) {// fetch locations (states, lgas, and countries)
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.locationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url,{}, { headers: header });// make api call
        state.commit('setLocations', response.data);
        return response.data;
    },
    async viewCpdDocument(state, filename) {// fetch user document function
        const authorizationToken = state.rootState.user.accessToken;
        const url = state.rootState.url.documentViewUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        try {
            const response = await axios.post(url, 
                        { filename: filename },
                        { responseType: 'blob', headers: header });// make api call
            const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );

            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            return blobUrl;
        } catch (error) {
            swal.fire("Error!", "Unable to view document", "error");
        }
    },
    async downloadAnyFiles(state, data) {
        const authorizationToken = state.rootState.user.accessToken;
        try {
            const response = await axios.post( data.url, data,
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${authorizationToken}`
                    },
                }
            );
            // trigger an actual file download (zip/archive), not just open in a tab
            const contentType = response.headers['content-type'] || data.contentType;
            const blobUrl = URL.createObjectURL(new Blob([response.data], { type: contentType }));

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = data.fileName; // adjust extension to match actual file type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);            
        } catch (error) {
            let errorMsg = data.msg;
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMsg = json.msg || json.message || text;
                } catch {
                    errorMsg = data.msg + ' ' + error.message;
                }
            } else {
                errorMsg = error.message || errorMsg;
            }
            swal.fire('Error!', error + ' - ' + errorMsg, 'error');
        }
        return false;
    }
};

const mutations = {
    setCpd: (state, cpd) => (state.cpd = cpd),// set user profile
    setCpdNotifications(state, data) {// set user notifications
        state.notifications.records = data.notifications.data;
        state.notifications.total = data.total;
    },
    setUpdatePhotoName: (state, fileName) => (state.cpd.photo = fileName),// set user basic profile only
    setLocations: (state, data) => (state.locations = data),// set locations (states, lgas, and countries)
};

export default {
    state,
    getters,
    actions,
    mutations
}